import { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import TextField from '@mui/material/TextField'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'

import './autocomplete.css'
import { Contacts } from '../../contactos/model'
import { Model } from '../../../models/model'

const filter = createFilterOptions();

export const AutocompleteRelacionados = ({ form, setForm }) => {

    const { listaPersonas } = useSelector(state => state.contacts)
    const [relacionados, setRelacionados] = useState([])

    const getRelacionados = useCallback(async () => {
        const relas = await Contacts.getRelacionados(form.id_cliente)
        const final = await Contacts.unionRela(relas, listaPersonas)
        setRelacionados(final)
    }, [listaPersonas, form.id_cliente])

    const handleChange = async (e, newValue) => {

        if (newValue && newValue.id > 0) {
            setForm({
                ...form,
                contacto_id: newValue.id,
                contacto_nombre: newValue.nombre,
                contacto_email: newValue.email
            })
        }

        if (!newValue.id) {

            // Creando nuevo contacto relacionado
            const newContact = {
                id: null,
                nombre: newValue.inputValue,
                clasificacion: 'cliente',
                tipo: 'persona',
                id_cliente: form.id_cliente
            }

            const resultData = await Model.save({
                url: 'contacts/relacionado',
                dataForm: newContact,
                resultData: true
            })

            if (resultData.id) {
                setForm({
                    ...form,
                    contacto_id: resultData.id,
                    contacto_nombre: resultData.nombre,
                    contacto_email: resultData.email
                })

                await getRelacionados()

            }


        }

    }

    useEffect(() => {
        getRelacionados()
    }, [getRelacionados])

    return (
        <Autocomplete
            value={relacionados?.find((it) => (parseInt(it.id) === parseInt(form.contacto_id))) || null}
            onChange={(e, newValue) => handleChange(e, newValue)}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;

                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.nombre);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        nombre: `Crear  "${inputValue}"`,
                    });
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="free-solo-with-text-demo"
            options={relacionados}
            getOptionLabel={(option) => {

                if (option.id > 0) {

                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }

                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                        return option.inputValue;
                    }

                    // Regular option
                    return option.nombre

                } else {

                    return ''

                }

            }}
            renderOption={(props, option) => <li {...props} style={{ borderBottom: option.id < 0 ? '1px solid rgb(230, 226, 226)' : '' }}>{option.nombre}</li>}
            sx={{ width: '100%' }}
            size='small'
            freeSolo
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Contacto relacionado"
                    placeholder='Ingrese nombre de tu contacto'
                    inputProps={{
                        ...params.inputProps,
                        style: { textTransform: 'capitalize' }
                    }}
                />
            )}
        />
    );
}